module.exports = __webpack_public_path__ + "img/1.ef4fd305.svg";